import React from "react";
import moment from "moment";
import { Form, DatePicker } from "antd";

const UiDatePicker = (props) => {
  const FormItem = Form.Item;
  const {
    title,
    name,
    mandatory,
    tabIndex,
    validation,
    format,
    picker,
    onChange,
    placeholder,
    disabled,
    value,
    className,
  } = props;
  return (
    <FormItem
      name={name}
      label={title}
      rules={validation}
      className={className}
    >
      <div>
        <DatePicker
          name={name}
          format={format}
          value={value}
          tabIndex={tabIndex}
          picker={picker}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(date, dateString) => onChange(date, dateString)}
          style={{ textTransform: "uppercase" }}
        />
      </div>
    </FormItem>
  );
};

export default UiDatePicker;
